import { withProps } from 'recompose';

import { Breadcrumbs } from 'components/core/Breadcrumbs';

const enhance = withProps({ segmentCategory: 'search breadcrumb interactions' });

export default enhance(Breadcrumbs);
